import { render, staticRenderFns } from "./edu_liyou_coupon_receive_page.vue?vue&type=template&id=7ac3c836&scoped=true"
import script from "./edu_liyou_coupon_receive_page.vue?vue&type=script&lang=js"
export * from "./edu_liyou_coupon_receive_page.vue?vue&type=script&lang=js"
import style0 from "./edu_liyou_coupon_receive_page.vue?vue&type=style&index=0&id=7ac3c836&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac3c836",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ac3c836')) {
      api.createRecord('7ac3c836', component.options)
    } else {
      api.reload('7ac3c836', component.options)
    }
    module.hot.accept("./edu_liyou_coupon_receive_page.vue?vue&type=template&id=7ac3c836&scoped=true", function () {
      api.rerender('7ac3c836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/edu_liyou/coupon/edu_liyou_coupon_receive_page.vue"
export default component.exports